export type ClientsModuleViewerFlags = {
  isCommercial: boolean;
  isComite: boolean;
  isInstrumentator: boolean;
  isAdmin: boolean;
  isRiskAnalyst: boolean;
};

/** Sidebar "Clientes" when global flag is on and role may access the module. */
export function shouldShowClientsModuleInSidebar(
  isClientEnabled: boolean,
  flags: ClientsModuleViewerFlags,
): boolean {
  if (!isClientEnabled) {
    return false;
  }
  return (
    flags.isCommercial ||
    flags.isComite ||
    flags.isInstrumentator ||
    flags.isAdmin ||
    flags.isRiskAnalyst
  );
}
